module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next"
  }, _vm._l((_vm.block), function(item, index) {
    return _c('div', _vm._l((item), function(e, k2) {
      return _c('b', {
        class: e ? 'c' : ''
      })
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9f43474"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/next/index.vue
// module id = 137
// module chunks = 1